import { useMaxWidth } from '@grupoboticario/flora-react';
import { app, settings, user, Utilities } from 'core';
import { UNCLASSIFIED_ERROR_ID } from 'core/middlewares/effects/orchestrator/workflows/error-handling';
import { Cookies } from 'core/utilities';
import { useNavigate } from 'react-router';

export function useFeedbackMessage() {
  const navigate = useNavigate();
  const homePath = '/departamentos';
  const {
    data: { avaliableCycles, resellerId, cycle },
  } = user.hooks.useUser();

  const isMobile = useMaxWidth('992px');

  const errorMessage =
    avaliableCycles.message === UNCLASSIFIED_ERROR_ID.INVALID_CREDENTIALS
      ? 'Não foi possível atualizar o ciclo, pois você possui pedidos pendentes. Ao finalizar os pedidos pendentes, tente novamente.'
      : 'No momento não conseguimos fazer a atualização de ciclo. Tente mais tarde.';

  const getTitle = {
    [Utilities.STATUS.SUCCESS]: 'Ciclo atualizado com sucesso!',
    [Utilities.STATUS.ERROR]: 'Não foi possível atualizar o ciclo',
  };

  const getMessage = {
    [Utilities.STATUS.SUCCESS]:
      'Você verá os produtos, preços e materiais do novo ciclo e poderá realizar quantos pedidos quiser.',
    [Utilities.STATUS.ERROR]: errorMessage,
  };

  const floraSection = {
    [Utilities.STATUS.SUCCESS]: 'captacao-estendida-mensagem-de-sucesso',
    [Utilities.STATUS.ERROR]: 'captacao-estendida-mensagem-de-erro',
  };

  const goToHome = () => {
    if (avaliableCycles.status === Utilities.STATUS.SUCCESS) {
      localStorage.setItem(`choose-new-cycle-${resellerId}`, 'true');
      Cookies.set('currentCycle', `${cycle.nextCycle}`, { domain: '.boticario.com.br' });
    } else {
      localStorage.setItem(`choose-extended-cycle-${resellerId}`, 'true');
      Cookies.set('currentCycle', `${cycle.currentCycle}`, { domain: '.boticario.com.br' });
    }
    navigate(homePath);
  };

  return {
    isMobile,
    getTitle,
    avaliableCycles,
    getMessage,
    floraSection,
    goToHome,
  };
}
